import { lazy } from 'react';

export const MonitoringListPage = lazy(
  () => import('@/pages/monitoring/ui/MonitoringPage/MonitoringPage.tsx'),
);

export const MonitoringDetailsPage = lazy(
  () => import('./ui/MonitoringDetailsPage/MonitoringDetailsPage'),
);

export const MonitoringCreatePage = lazy(
  () => import('./ui/MonitoringCreateFormPage/MonitoringCreateFormPage'),
);

export const MonitoringUpdatePage = lazy(
  () => import('./ui/MonitoringUpdateFormPage/MonitoringUpdateFormPage'),
);
